import React from 'react'
import './ReadOut.scss'

const { fileTemplateUrl } = window.JMO;

class ReadOut extends React.Component {
  render() {
    return (
      <div id="readout">
        <dl className="category">
          <dt>[カテゴリー]</dt>
          {this.props.category.map(d => {
            const fragStyle = { backgroundColor: d.color }
            return (
              <dd className={'cat_' + d.id} key={d.id}>
                <span className="color" style={fragStyle} />
                {d.name}
              </dd>
            )
          })}
        </dl>

        <dl className="fragrance">
          <dt>[香り]</dt>
          {this.props.frag.map(d => {
            return (
              <dd className={'fragrance_' + d.id} key={d.id}>
                <span className="icon" >
                  <img src={fileTemplateUrl.replace('FILENAME', `icon_g_${d.id}.svg`)} alt="icon" />
                </span>
                {d.name}
              </dd>
            )
          })}
        </dl>
      </div>
    )
  }
}
export default ReadOut
